/**
 * Created by Ning Jiang on 4/19/2016.
 */

import { ParsedGameData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import { ServerDataParser } from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import { ISanGameData, IAllWinData, SanJumpData, SanJumpDataSection } from "./ISanServerData";
import { IBetWayWinData } from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { SanGameConfig } from "../../SanGameConfig";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export interface SanBetWayWinData extends IBetWayWinData{
    reelWinLvlPositions: number[][];
    winLvl:number;
}

export class SanParsedGameData extends ParsedGameData {
    
    private _rawData:ISanGameData;
    private readonly _allWinData:IAllWinData;

    private readonly _wildReelPositions:number[][];

    private readonly _scatterReelPositions:number[];
    private readonly _mystReelPositions:number[][];

    private readonly _fsMergedReel:string[][];
    
    private readonly _scatterAmount:number;
    private readonly _wildAmount:number;

    private readonly _fsStartAmount:number;

    private readonly _nearWinMap:number[][];
    private readonly _miniBonus:boolean = false;

    private readonly _possibleWays:number = 0;
    private readonly _sanJumpData:SanJumpData[];

    private readonly _sanBetWays:SanBetWayWinData[];

    private readonly _fsSym:{sym:string,val:number};

    private readonly _ignoreBigWin:boolean = false;

    private readonly _countedWays:number[];

    public get countedWays():number[] {
        return this._countedWays;
    }

    public get sanBetWays():SanBetWayWinData[] {
        return this._sanBetWays;
    }

    public get possibleWays():number {
        return this._possibleWays;
    }

    public get sanJumpData():SanJumpData[] {
        return this._sanJumpData;
    }

    public get nearWinMap():number[][] {
        return this._nearWinMap;
    }

    public get rawData():ISanGameData{
        return this._rawData;
    }

    public get allWinData():IAllWinData {
        return this._allWinData;
    }

    public get fsStartAmount():number {
        return this._fsStartAmount;
    }

    public get scatterAmount():number {
        return this._scatterAmount;
    }

    public get wildAmount():number {
        return this._wildAmount;
    }
    
    public get mystReelPositions():number[][]{
        return this._mystReelPositions;
    }

    public get scatterReelPositions():number[]{
        return this._scatterReelPositions;
    }

    public get wildReelPositions():number[][]{
        return this._wildReelPositions;
    }

    public get isMiniBonus():boolean{
        return this._miniBonus;
    }

    public get fsSym():{sym:string,val:number}{
        return this._fsSym;
    }

    public get isRealBigwin():boolean{
        return this._ignoreBigWin;
    }

    public get fsMergedreel():string[][]{
        return this._fsMergedReel;
    }

    constructor(rawData:ISanGameData, dataParser:ServerDataParser) {
        super(rawData, dataParser);

        this._rawData = rawData;

        const symKey:string = Object.keys(rawData.specialSymbol)[0];
        this._fsSym = {sym:symKey,val:rawData.specialSymbol[symKey]};

        this._sanBetWays = this.addBetLvls(rawData.betWayWins!)
        
        this._scatterReelPositions = this.findOneSymbol(ReelSymbolName.SCATTER);
        this._mystReelPositions = this.findMultSymbol("Z");
        this._wildReelPositions = this.findMultSymbol(ReelSymbolName.WILD);
        this._sanJumpData = this.jumpDecryption(rawData.stickyWildPositions)
        
        this._fsMergedReel = this.reelFSMerge();
        this._nearWinMap = rawData.mode === GameMode.NORMAL ? this.createNormalNearWinMap() : this.createFSNearWinMap();
        this._allWinData = this.parseAllHits(this._sanBetWays);

        this._scatterAmount = this.countArrayPos(this._scatterReelPositions);
        this._wildAmount = this.countArrayPos(this.findOneSymbol(ReelSymbolName.WILD));
        this._miniBonus = rawData.mode == "NORMAL" && this._scatterAmount == 2;

        this._ignoreBigWin = this.currentWinRatio > (SanGameConfig.instance.WIN_RATIOS.bigWin[0].ratio*1.15);

        this._possibleWays = this.createPossibleWays();
        this._fsStartAmount = this.countFS();

        this._countedWays = this.mode === GameMode.FREESPIN ?  this.countfsWays() : [];
    }

    private addBetLvls(data:IBetWayWinData[]):SanBetWayWinData[]{

        const temp:SanBetWayWinData[] = [];
        
        for(let d:number = 0; d < data.length; d++){
            const betGrp:SanBetWayWinData = <SanBetWayWinData>data[d];

            let winLvl:number = 0;
            const amountRatio:number = data[d].amount/parseFloat(this.rawData.playedBetValue);
            SanGameConfig.instance.WIN_RATIOS!.normalWin.forEach((v,i) => v.ratio <= amountRatio ? winLvl = i : winLvl )

            betGrp.reelWinLvlPositions = [];
            betGrp.winLvl = winLvl;
            for(let reel:number = 0; reel < data[d].reelWinPositions.length; reel++){
                betGrp.reelWinLvlPositions[reel] = [];
                for(let row:number = 0; row < data[d].reelWinPositions[reel].length; row++){
                    betGrp.reelWinLvlPositions[reel][row] = data[d].reelWinPositions[reel][row] ? winLvl : -1;
                }
            }

            temp.push(betGrp);
        }

        temp.sort((a,b) => { return a.winLvl - b.winLvl; });

        return temp;
    }

    private countBarTopWays(checkArr:string[]):number[]{
        const arr:number[] = [];

        for(let r:number = 0; r < checkArr.length; r++){

            if(this.rawData.topRowOpened[r]){
                if(containsSmall(checkArr[r])){
                    arr.push(3);
                }else if(containsBig(checkArr[r])){
                    arr.push(4);
                }else{
                    arr.push(1);
                }
            }else{
                arr.push(0);
            }
        }

        function containsBig(s:string):boolean{
            return s === "XWAYS";
        }

        function containsSmall(s:string):boolean{
            return s === "X2";
        }

        return arr;
    }

    private countBarBottWays(botArr:string[],topArr:number[]):number[]{
        const arr:number[] = [];

        for(let r:number = 0; r < botArr.length; r++){

            if(this.rawData.topRowOpened[r]){
                if(containsSmall(botArr[r])){
                    arr.push(topArr[r] == 3 ?  9 : 3);
                }else if(containsBig(botArr[r])){
                    arr.push(4);
                }else{
                    arr.push(1);
                }
            }else{
                arr.push(0);
            }
        }

        function containsBig(s:string):boolean{
            return s === "XWAYS";
        }

        function containsSmall(s:string):boolean{
            return s === "X2";
        }

        return arr;
    }

    private countJwMult(jwData:SanJumpData[]):number[]{
        const arr:number[] = ArrayHelper.initArrayWithValues(SanEngineManager.AllReels.length,() =>  3);

        for(let r:number = 0; r < jwData.length; r++){
            const reel:number = jwData[r].to.reel;
            const mult:number = jwData[r].to.multiplier != undefined ? jwData[r].to.multiplier! - 1 : 0;
            arr[reel] += mult;
        }
        return arr;
    }


    private countfsWays():number[]{
        const arr:number[] = [];

        const topBarWays:number[] = this.countBarTopWays(this.rawData.cellReelOne);
        const botBarWays:number[] = this.countBarBottWays(this.rawData.cellReelTwo, topBarWays);
        const jwMultReel:number[] = this.countJwMult(this.sanJumpData);

        for(let t:number  = 0; t < 2; t++){
            let offSet:number = 0;
            if(t == 0){
                for(let k:number = 0; k < this.reels.length;k++){
                    let val:number = jwMultReel[0] + topBarWays[0];
                    for(let j:number = 1; j < this.reels.length;j++){
                        val *=  jwMultReel[k] + (offSet >= j ? topBarWays[j] : 0);
                    }
                    arr.push(val);
                    offSet++;
                }
            }
            else{

                let startVal:number = jwMultReel[0];

                if(topBarWays[0] + botBarWays[0] == 8)
                    startVal = 8 + (jwMultReel[0]-3);
                else if(topBarWays[0] + botBarWays[0] >= 8){
                    startVal = 12 + (jwMultReel[0]-3);
                }else
                    startVal += topBarWays[0] + botBarWays[0];

                for(let k:number = 0; k < this.reels.length;k++){
                    let val = startVal;
                    for(let j:number = 1; j < this.reels.length;j++){

                        let tbNorm:number = jwMultReel[k] + topBarWays[j] + (offSet >= j ? botBarWays[j] : 0);
                        const tbMerge:number = topBotCheck(topBarWays[j], botBarWays[offSet]);

                        if(tbMerge == 8 || tbMerge == 12)
                            val *= tbMerge + (jwMultReel[j]-3);
                        else
                            val *= tbNorm;
                    }

                    arr.push(Math.min(Math.max(arr[arr.length-1],val),this.rawData.totalWays));
                    offSet++;
                }
            }
        }

        function topBotCheck(a:number, b:number):number{
            if(a + b == 8)
                return 8;
            else if(a + b >= 8){
                return 12;
            } else
                return a+b;
        }


        return arr;
    }

    private countFS():number{
        if(this._rawData.mode == GameMode.NORMAL) return 0;
        let temp:number = 0;
        for(let i:number = 0; i < this._rawData.topRowOpened.length;i++){
            if(!this._rawData.topRowOpened[i]) continue;
            temp += parseInt(this._rawData.cellReelOne[i]) + parseInt(this._rawData.cellReelTwo[i]);
        }
        return temp;
    }

    private createPossibleWays():number{
        let temp:number = 0;
        for(let r:number = 0; r < SanEngineManager.AllReels.length;r++){
            let amm:number = this.containsXWays(r) ? 8 : 3;
            if(r == 0) 
                temp = amm;
            else
                temp *= amm;
        }
        return temp;
    }

    private containsXWays(reel:number):boolean{
        return this._rawData.cellReelOne[reel] == "XWAYS" || this._rawData.cellReelTwo[reel] == "XWAYS";
    }

    private jumpDecryption(jumpData:string):SanJumpData[]{
        const amountOfJumpers:string[] = jumpData.split(";").filter((s) => { return s });
        const arr:SanJumpData[] = [];
        
        for(let j:number= 0; j < amountOfJumpers.length; j++){
            const splittedData:string[] = amountOfJumpers[j].split(":");
            arr.push( defining(
                pos(splittedData[0]), // Reel
                pos(splittedData[1]), // Row
                [ parseFloat(splittedData[2]),parseFloat(splittedData[3]) // Multi
            ]));
        }

        function defining (from:number[],to:number[],multiplier:number[]):SanJumpData{
            return { 
                from:{ reel:from[0], row:from[1], multiplier:multiplier[0]} ,
                to: { reel:to[0], row:to[1], multiplier:multiplier[1]} };
        }
        
        function pos (val:string):number[]{
             return val.split(",").map((s:string) => { if(parseFloat(s) < 0 ) return 0; return parseFloat(s)});
         }

        return arr;
    }

    private parseAllHits(betW:SanBetWayWinData[]):IAllWinData{
        let allWinData:IAllWinData = {
            symbols:[],
            longest:0,
            reelWinPositions:[],
            reelWinLvlPositions:[],
            totalWinCombination:0,
            biggestWinLvl:0,
        };

        for(let i:number = 0; i < this.reels.length;i++){
            allWinData.reelWinPositions.push([])
            allWinData.reelWinLvlPositions.push([])
            for(let j:number = 0; j < 5;j++){
                allWinData.reelWinPositions[i].push(false);
                allWinData.reelWinLvlPositions[i].push(-1);
            }
        }

        for(let groups = 0; groups < betW!.length;groups++){
            const winData:SanBetWayWinData = betW![groups];
            
            allWinData.symbols.push(winData.symbol);
            allWinData.totalWinCombination += winData.numberOfCombinations;
            if(winData.length > allWinData.longest) allWinData.longest = winData.length;

            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row]){
                        allWinData.reelWinPositions[reel][row] = posRow[row];
                        allWinData.reelWinLvlPositions[reel][row] = winData.reelWinLvlPositions[reel][row];
                        if(allWinData.biggestWinLvl < winData.reelWinLvlPositions[reel][row]) allWinData.biggestWinLvl = winData.reelWinLvlPositions[reel][row];
                    } 
                }
            }
        }

        return allWinData;
    }

    private reelFSMerge():string[][]{
        const rHeight:number = 5;

        // For some reason, this is the only solution i got to bypass the reference.
        const reelCopied:string[][] = [];
        for(let i = 0; i < this.reels.length;i++){
            reelCopied.push(Array.from(this.reels[i]));
        }

        for(let i = 0; i < reelCopied.length;i++){
            if(!this.rawData.topRowOpened[i]) continue;
            reelCopied[i][0] = this.rawData.cellReelOne[i];
            reelCopied[i][4] = this.rawData.cellReelTwo[i];

            if(this.containsXWays(i)){
                if(this.rawData.cellReelOne[i] === this.rawData.cellReelTwo[i]){
                    for(let k = 1; k < reelCopied.length+1;k++)
                        reelCopied[i][k] = "W";
                }
            }
        }

        for(let j:number = 0; j < this.sanJumpData.length;j++){
            reelCopied[this.sanJumpData[j].to.reel][this.sanJumpData[j].to.row+1] = "W";
        }
    
        return reelCopied;
    }

    private createFSNearWinMap():number[][]{

        const rHeight:number = 5;

        // For some reason, this is the only solution i got to bypass the reference.
        const reelCopied:string[][] = this._fsMergedReel;
        
        let startM:number[] = ArrayHelper.initArrayWithValues( this.rawData.topRowOpened[0] ? rHeight : 3,(index:number) => {return this.rawData.topRowOpened[0] ? index : index+1;});
        let map:number[][] = [startM];

         // WildConnection
        for(let w:number = 0; w < reelCopied.length;w++){
            if(reelCopied[w].indexOf(ReelSymbolName.WILD) >= 0 && map.length != 5)
                map.push(ArrayHelper.initArrayWithValues(this.rawData.topRowOpened[w] ? rHeight : 3,(index:number) => {return this.rawData.topRowOpened[w] ? index : index+1;}));
            else break;
        }

        const checkSymStartOffset:number = map.length;
        // Create normal map for symbols that crosses itself and special symbols.
        for(let offs:number = 0; offs < checkSymStartOffset;offs++){
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let startSym:string = reelCopied[offs][symPos];

                if(startSym === ReelSymbolName.WILD) continue;
                for(let reel:number = 1; reel < SanEngineManager.AllReels.length;reel++){
                    let arrFindings:number[] = findSymbolPos(reel, [startSym, ReelSymbolName.WILD],[ReelSymbolName.SCATTER,ReelSymbolName.BONUS]);
                    if(arrFindings.length == 0) break;
                    if(map.length == reel)
                        map.push([]);

                    for(let j:number = 0; j < arrFindings.length;j++) 
                        if(map[reel].indexOf(arrFindings[j]) == -1 ) map[reel].push(arrFindings[j]);
                }
                map = map.filter(arr => { return arr.length > 0} )
            }
        }

        function findSymbolPos(reel:number,symbol:string[],ignoreSymbol:string[]):number[]{
            let temp:number[] = [];
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let sym = reelCopied[reel][symPos];
                if(ignoreSymbol.indexOf(sym) >= 0) continue;
                if(symbol.indexOf(sym) >= 0 && temp.indexOf(symPos) == -1) temp.push(symPos);
            }
            return temp;
        }
        
        return map;
    }

    private createNormalNearWinMap():number[][]{

        const rHeight:number = 3;

        // For some reason, this is the only solution i got to bypass the reference.
        const reelCopied:string[][] = [];
        for(let i = 0; i < this.reels.length;i++){
            reelCopied.push(Array.from(this.reels[i]));
        }
        
        let startM:number[] = ArrayHelper.initArrayWithValues(rHeight,(index:number) => {return index;});
        let map:number[][] = [startM];

         // WildConnection
        for(let w:number = 0; w < reelCopied.length;w++){
            if(reelCopied[w].indexOf(ReelSymbolName.WILD) >= 1 && reelCopied[w].indexOf(ReelSymbolName.WILD) < 4 && map.length != 5)
                map.push(ArrayHelper.initArrayWithValues(rHeight,(index:number) => {return index;}));
            else break;
        }

        const checkSymStartOffset:number = map.length;
        // Create normal map for symbols that crosses itself and special symbols.
        for(let offs:number = 0; offs < checkSymStartOffset;offs++){
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let startSym:string = reelCopied[offs][symPos+SanGameConfig.instance.REEL_ENGINE_CONFIG.OVERFLOW_BOTT];

                if(startSym === ReelSymbolName.WILD) continue;
                for(let reel:number = 1; reel < SanEngineManager.AllReels.length;reel++){
                    let arrFindings:number[] = findSymbolPos(reel, [startSym, ReelSymbolName.WILD],[ReelSymbolName.SCATTER,ReelSymbolName.BONUS]);
                    if(arrFindings.length == 0) break;
                    if(map.length == reel)
                        map.push([]);

                    for(let j:number = 0; j < arrFindings.length;j++) 
                        if(map[reel].indexOf(arrFindings[j]) == -1 ) map[reel].push(arrFindings[j]);
                }
                map = map.filter(arr => { return arr.length > 0} )
            }
        }

        function findSymbolPos(reel:number,symbol:string[],ignoreSymbol:string[]):number[]{
            let temp:number[] = [];
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let sym = reelCopied[reel][symPos+1];
                if(ignoreSymbol.indexOf(sym) >= 0) continue;
                if(symbol.indexOf(sym) >= 0 && temp.indexOf(symPos) == -1) temp.push(symPos);
            }
            return temp;
        }
        return map;
    }

    private findMultSymbol(symbol:string):number[][]{
        let arr:number[][] = [];

        for(let reel = 0; reel < this.reels.length; reel++){
            arr.push([])
            for(let row:number = 0; row < 3; row++){
                if(this.reels[reel][row+1] == symbol){
                    arr[reel].push(row);
                } 
            }
        }
        return arr;
    }

    private findOneSymbol(symbol:string):number[]{
        let arr:number[] = [];

        for(let reel = 0; reel < this.reels.length; reel++){
            let pos:number = -1;
            for(let row:number = 0; row < 3; row++){
                if(this.reels[reel][row+1] == symbol){
                    pos = row;
                    break;
                } 
            }
            arr.push(pos);
        }
        return arr;
    }

    private countArrayPos(arr:number[]):number{
        let count:number = 0;
        arr.forEach(val => { if(val >= 0 && val <= 2) count++;});
        return count;
    }
}